import { Bar } from 'public/charting_library/charting_library';

export interface AevoHistoricalData {
  time: number;
  open: string;
  high: string;
  low: string;
  close: string;
  volume: string;
}

export async function getHistoricalData(opts: {
  symbol: string;
  interval: string;
  from?: number;
  to?: number;
}): Promise<Bar[]> {
  const queryParams: Record<string, any> = {
    symbol: opts.symbol,
    resolution: opts.interval,
  };

  if (opts?.to) {
    queryParams.to = opts.to / 1000;
  }
  const domain =
    'https://zks-pricing.holdstation.com/last-traded-tradingview/history';
  const params = new URLSearchParams(queryParams);
  const url = `${domain}?${params.toString()}`;
  try {
    const res = await fetch(url);
    const data = await res.json();

    if (data.status < 200 || data.status >= 400) {
      throw new Error(`${data.status}`);
    }

    const resp = data.data;
    if (resp.s !== 'ok') {
      throw new Error("Can't get data history");
    }

    const result: Bar[] = [];
    for (let index = 0; index < resp.t.length; index++) {
      result.push({
        time: resp.t[index] * 1000,
        /** Opening price */
        open: resp.o[index],
        /** High price */
        high: resp.h[index],
        /** Low price */
        low: resp.l[index],
        /** Closing price */
        close: resp.c[index],
        /** Trading Volume */
        volume: resp.v[index],
      });
    }
    return result;
  } catch (error) {
    console.error('Error call zks historical data', error);
    return [];
  }
}
